module.exports = __webpack_public_path__ + "/bundle/asset/nsdua-logo-571d23a3a7d973489c99e7e3c4ac3372.png";